import React from 'react';

import { useFormContext } from 'react-hook-form';

import { z } from 'zod';

import { FormControl, FormField, FormItem, FormMessage } from 'components/ui';

import { templateStudioSchema } from '../../../validation-schema';
import { TemplateStudioSlider } from '../Components/TemplateStudioSlider';
import { ThemesFormItem } from '../Components/ThemesFormItem';

export const TemplateStudioPromotionForm: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  return (
    <>
      <FormField
        control={control}
        name="promotion.themes"
        render={({ field }) => (
          <ThemesFormItem onChange={field.onChange} value={field.value || []} />
        )}
      />
      <FormField
        control={control}
        name="promotion.maxSupportedProducts"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <TemplateStudioSlider
                value={field.value ?? 1}
                onChange={field.onChange}
                label="Max products supported"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
